import { render, staticRenderFns } from "./AIVoiceMonitor.vue?vue&type=template&id=b9cd1d72&scoped=true"
import script from "./AIVoiceMonitor.vue?vue&type=script&lang=js"
export * from "./AIVoiceMonitor.vue?vue&type=script&lang=js"
import style0 from "./AIVoiceMonitor.vue?vue&type=style&index=0&id=b9cd1d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cd1d72",
  null
  
)

export default component.exports